import { Alert as AntAlert } from 'antd'
import type { ComponentProps } from 'react'

type AntAlertProps = ComponentProps<typeof AntAlert>

export interface AppAlertProps extends AntAlertProps {}

export const AppAlert = (props: AppAlertProps) => <AntAlert {...props} />
